<ng-container *ngIf="holiday$ | async | ready as feature">
  <app-panel [expandable]="false" [expanded]="true" *ngIf="isScheduled && !isOutdated">
    <app-panel-header>
      <ng-container message *ngIf="isMultiFamily">
        {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.CIRCUIT' | translate }} {{ circuitIdToDisplay }}
      </ng-container>
      <ng-container message>
        <ng-container *ngIf="isHolidayAtHome; else holidayProgram">
          {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.HOLIDAY_AT_HOME.TITLE' | translate }}
        </ng-container>
        <ng-template #holidayProgram>
          {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.TITLE' | translate }}
        </ng-template>
      </ng-container>
    </app-panel-header>
    <app-panel-content
      class="flex flex-col md:flex-row gap-[8px] justify-start items-stretch md:justify-between md:items-center"
    >
      <ng-container description>
        <div data-at-scheduled-message>
          {{
            '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.ACTIVE_FROM_UNTIL'
              | translate
                : {
                    startDate: departureDate.toDate() | date: 'short',
                    endDate: returnDate.toDate() | date: 'short'
                  }
          }}
        </div>
      </ng-container>

      <div class="action-row flex flex-row">
        <button
          button
          class="deactivate-btn"
          data-at-deactivate-holiday-btn
          mat-stroked-button
          color="accent"
          gtm="onOpen"
          gtmAction="Deactivate holiday program dialog"
          gtmCategory="statusPanel"
          [disabled]="!(feature | executable: 'unschedule') || isRemoteDiagnostic"
          [viConfirm]="{
            title: deactivateDialogTitle | translate,
            content: deactivateDialogContent | translate,
            cancelBtn:
              '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DEACTIVATE_DIALOG.CANCEL' | translate,
            confirmBtn:
              '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DEACTIVATE_DIALOG.CONFIRM' | translate
          }"
          (confirm)="onUncheduleHolidayMode()"
          (cancel)="onCancelUncheduleHolidayMode()"
        >
          {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.BUTTON' | translate }}
        </button>
        <app-set-holiday-mode
          displayText="{{ 'GENERAL.BUTTON.EDIT' | translate }}"
          data-at-edit-holiday-btn
          [holidayType]="holidayProgramType"
          [circuitId]="circuitId"
          [isRemoteDiagnostic]="isRemoteDiagnostic"
          color="accent"
          appLargeButton
          gtm="onOpen"
          gtmAction="Cancel monitoring service dialog"
          gtmCategory="deviceCard"
        ></app-set-holiday-mode>
      </div>
    </app-panel-content>
  </app-panel>
</ng-container>
